import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MetabaseModuleDashboardEmbedUrlQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  teamId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MetabaseModuleDashboardEmbedUrlQuery = { __typename: 'PharosQuery', metabaseModuleDashboard: { __typename: 'MetabaseModuleDashboardType', id: string, name: string, embedUrl: string } | null };


export const MetabaseModuleDashboardEmbedUrlDocument = gql`
    query metabaseModuleDashboardEmbedUrl($id: ID!, $teamId: String) {
  metabaseModuleDashboard(id: $id) {
    id
    name
    embedUrl(teamId: $teamId)
  }
}
    `;

/**
 * __useMetabaseModuleDashboardEmbedUrlQuery__
 *
 * To run a query within a React component, call `useMetabaseModuleDashboardEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetabaseModuleDashboardEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetabaseModuleDashboardEmbedUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useMetabaseModuleDashboardEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables> & ({ variables: MetabaseModuleDashboardEmbedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>(MetabaseModuleDashboardEmbedUrlDocument, options);
      }
export function useMetabaseModuleDashboardEmbedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>(MetabaseModuleDashboardEmbedUrlDocument, options);
        }
export function useMetabaseModuleDashboardEmbedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>(MetabaseModuleDashboardEmbedUrlDocument, options);
        }
export type MetabaseModuleDashboardEmbedUrlQueryHookResult = ReturnType<typeof useMetabaseModuleDashboardEmbedUrlQuery>;
export type MetabaseModuleDashboardEmbedUrlLazyQueryHookResult = ReturnType<typeof useMetabaseModuleDashboardEmbedUrlLazyQuery>;
export type MetabaseModuleDashboardEmbedUrlSuspenseQueryHookResult = ReturnType<typeof useMetabaseModuleDashboardEmbedUrlSuspenseQuery>;
export type MetabaseModuleDashboardEmbedUrlQueryResult = Apollo.QueryResult<MetabaseModuleDashboardEmbedUrlQuery, MetabaseModuleDashboardEmbedUrlQueryVariables>;